<template>
  <h2 class="titleLinelogo"><router-link :to="{path:'/'}"><img src="@/assets/images/mamadays_linelogo.png" alt="MAMADAYS総選挙"></router-link></h2>
  <div class="categorysPage">
    <div class="categoryTitle">
      <div class="productImage">
        <p class="number">0{{ targetCategoryNumber }}</p>
        <template v-if="targetCategory !== null && targetCategory.hasOwnProperty('departments')">
          <p class="product active"><img v-bind:src="'/products/' + targetCategory.id + '/' + targetCategory.departments[targetCategory.representativeIndex].id + '.png'"></p>
          <div class="horizontalBar" v-bind:style="{ backgroundColor: targetCategory.departments[targetCategory.representativeIndex].themeColor}"></div>
        </template>  
      </div>
      <p class="pageLink">ジャンル | <span class="fontPink">{{ targetCategory ? targetCategory.name : ""  }}</span></p>
    </div>

    <section class="departments">
      <template v-for="department in targetCategory ? targetCategory.departments : []" :key="department.id" >
        <section v-if="department.ishiddenAsDepartment !== true" class="department" v-bind:id="department.id">
          <h3 class="title">{{ department.name }}部門</h3>
          <div class="item_container">
            <section class="product" v-for="product in departmentsData !== undefined && departmentsData[department.id] !== undefined ? departmentsData[department.id].products : []" :key="product.id" v-bind:class="product.id">
              <figure>
                <h4 v-if="product.emblem !== null" class="award"><img v-bind:src="require('@/assets/images/departments/' + department.id + '_' + product.emblem + '.png')" alt="MAMA DAYS 総選挙 授乳食事部門 最優秀賞"></h4>
                <img v-bind:src="'/products/' + targetCategory.id + '/' + department.id + '/' + product.id + '.jpg'">
              </figure>
              <p class="companyName">
                <span v-html="product.companyName"></span>
                <span v-if="product.brandName !== null" v-html="'<br/>(' + product.brandName + ')'"></span>
              </p>
              <h4 class="name" v-html="product.name"></h4>
              <a class="button" v-on:click="sendTracking('クリック', targetCategory.id, product.companyName+'_'+product.name )" v-bind:href="product.pageUrl" target="_blank"><span class="textEl">詳細はこちら</span><span class="bg"></span></a>
              <section class="kutikomi">
                <div class="comment" v-for="(comment, index) in product.comments !== undefined && product.comments.length ? product.comments : []" :key="index">
                  <h5 class="mamasIcon"><img v-bind:src="require('@/assets/images/' + comment.auther + '_comment.png')"></h5>
                  <div class="message">
                    <p  v-if="comment.moreComment !== null" class="text" v-html="comment.comment + '...'"></p>
                    <p  v-else class="text" v-html="comment.comment"></p>
                    <p v-if="comment.moreComment !== null" v-on:click="openContent($event,comment.moreComment,comment.comment)" class="viewMore en"><span>VIEW MORE</span><span class="circle"></span></p>
                  </div>
                </div>
              </section>
              <small class="annotation" v-if="product.annotation !== undefined" v-html="product.annotation"></small>
            </section>
          </div>
        </section>
      </template>
    </section>

    <section class="categoryLinks">
      <h3 class="title">他のジャンルをCHECK!!</h3>
      <ul class="links">
        <li v-for="category in categoryDefinition.categorys" :key="category.id"><router-link :to="{path:'/'+category.id}">{{ category.name }}<span class="bg"><span class="circle"></span></span></router-link></li>
      </ul>
    </section>
  </div>
</template>


<script>
import { TimelineLite,Expo } from 'gsap'
import store from '@/store/index.js'
import util from '@/jsUtil/util'
export default {
  name: 'Categorys',
  
  created: function () {
   //ここが一番最初に遷移してコンポーネントを作成した時(つまりurl直打ちし最初にコンポーネントされる時)の挙動になる。
  },

  data () {
    return {
      events: {},
      categoryDefinition: [],
      departmentsData: null,
      targetCategory: null,
      targetCategoryNumber: 0
    }
  },

  mounted () {
    this.removePinkMode();
    this.hiddenNavigation();
    this.unsubscribe = store.subscribe((mutation, state) => {
      switch(mutation.type) {
        case "storeCategoryDefinitions":
          if (store.state.categoryDefinition != null) {
            this.categoryDefinition = JSON.parse(JSON.stringify(store.state.categoryDefinition));
            this.SetTargetCategory();
          }
          break;
        case "storeDepartments":
          if (store.state.departments != null) {
            this.departmentsData = JSON.parse(JSON.stringify(store.state.departments));
          }
          break;
      }
    });

    store.commit("setOnlineShopUrl","https://bit.ly/2JQ53DJ");
    if (store.state.categoryDefinition != null) {
      // vuex自体が変更されてしまうのでローカルで保持
      // 逆に全部反映させたい場合はそのまま代入する
      this.categoryDefinition = JSON.parse(JSON.stringify(store.state.categoryDefinition));
      this.SetTargetCategory();
    }
    if (store.state.departments != null) {
      this.departmentsData = JSON.parse(JSON.stringify(store.state.departments));
    }

    setTimeout(()=>{
      this.clearRepeatingUpdateIndex();
      this.repeatingUpdateIndex();
    },3500);
  },

	beforeRouteEnter (to, form, next) {
    const self = this;
    const resolver_anim_url = (imgurl) => {
      return new Promise((resolve,reject) => {
        const url = imgurl;
        const img = new Image();
        img.onload = () => resolve(imgurl);
        img.onerror = (e) => reject(e);
        img.src = url;
      });
    }

    const preloadProducts = async () => {
      const target = store.state.categoryDefinition.categorys.filter( category => category.id == to.params.id );
      target[0].departments.forEach( async (department,i)=>{
        if(department.ishiddenAsDepartment !== true) {
          const products =  store.state.departments[department.id].products;
          products.forEach( async (product,pi)=>{
            const productImagePath = "/products/" +  target[0].id + "/" + department.id + "/" + product.id + ".jpg";
            await resolver_anim_url(productImagePath);
          });
          const representImagePath = "/products/" +  target[0].id + "/" + department.id + ".png";
          await resolver_anim_url(representImagePath);
        } else {
          const representImagePath = "/products/" +  target[0].id + "/" + department.id + ".png";
          await resolver_anim_url(representImagePath);
        }
      })
    }

    const sleep = (time) => {
      return new Promise((resolve, reject) => {
          setTimeout(() => {
              resolve();
          }, time);
      });
    }

    let handleTouchMove = (event) => {
      event.preventDefault();
    }

    if (!store.state.isFirstLoad) {
      next();
      document.addEventListener('touchmove', handleTouchMove, { passive: false });
      document.querySelector("body").style.overflow = "hidden";
      preloadProducts().then( async (res) => {
        await sleep(450);
        store.commit("toggleOpen");
        let tl = new TimelineLite({ onComplete: () => { 
          tl.kill(); 
          document.querySelector("body").style.overflow = "auto";
          document.removeEventListener('touchmove', handleTouchMove, { passive: false });
          store.commit("readyToSetFollowAnimation");
        }});
        tl.delay(0.8).set(".PageAnimation", { display: "none"});
      });
    } else {
      document.addEventListener('touchmove', handleTouchMove, { passive: false });
      document.querySelector("body").style.overflow = "hidden";
      next();
      store.commit("alreadyLoad");
      preloadProducts().then((res)=>{
        let tl = new TimelineLite({ onComplete: () => {
          store.commit("toggleOpen");
          let innertl = new TimelineLite({ onComplete: () => { 
            document.querySelector("body").style.overflow = "auto";
            document.removeEventListener('touchmove', handleTouchMove, { passive: false });
            store.commit("readyToSetFollowAnimation");
            innertl.kill(); 
          }});
          innertl.delay(0.8).set(".PageAnimation", { display: "none"});
          const openingEl = document.querySelector(".PageAnimation .opening");
          openingEl.parentNode.removeChild(openingEl);
          tl.kill();
        }});
        tl.delay(3.0).to(".PageAnimation .opening", 0.6, { opacity: 0});
      });
    }
  },

	beforeRouteUpdate (to, form, next) {
    const resolver_anim_url = (imgurl) => {
      return new Promise((resolve,reject) => {
        const url = imgurl;
        const img = new Image();
        img.onload = () => resolve(imgurl);
        img.onerror = (e) => reject(e);
        img.src = url;
      });
    }

    const preloadProducts = async () => {
      const target = store.state.categoryDefinition.categorys.filter( category => category.id == to.params.id );
      target[0].departments.forEach( async (department,i)=>{
        if(department.ishiddenAsDepartment !== true) {
          const products =  store.state.departments[department.id].products;
          products.forEach( async (product,pi)=>{
            const productImagePath = "/products/" +  target[0].id + "/" + department.id + "/" + product.id + ".jpg";
            await resolver_anim_url(productImagePath);
          });
          const representImagePath = "/products/" +  target[0].id + "/" + department.id + ".png";
          await resolver_anim_url(representImagePath);
        } else {
          const representImagePath = "/products/" +  target[0].id + "/" + department.id + ".png";
          await resolver_anim_url(representImagePath);
        }
      })
    }

    const sleep = (time) => {
      return new Promise((resolve, reject) => {
          setTimeout(() => {
              resolve();
          }, time);
      });
    }

    let handleTouchMove = (event) => {
      event.preventDefault();
    }

    // スクロールさせない
    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    document.querySelector("body").style.overflow = "hidden";
    store.commit("stopToSetFollowAnimation");
    let tl = new TimelineLite({ onComplete: () => {
      store.commit("toggleInitOpen");
      setTimeout( () => { 
        store.commit("toggleInitOpen");
        store.commit("toggleOpen");
        setTimeout( () => {
          next();
        },600);
      }, 100);
      preloadProducts().then( async (res)=>{
        await sleep(800);
        this.SetTargetCategory();
        this.hiddenNavigation();
        store.commit("toggleOpen");
        document.querySelector("body").style.overflow = "auto";
        document.removeEventListener('touchmove', handleTouchMove, { passive: false });
        store.commit("readyToSetFollowAnimation");
        await sleep(800);
        let innerTl = new TimelineLite({ onComplete: () => { 
          tl.kill(); 
          innerTl.kill(); 
        }});
        innerTl.set(".PageAnimation", { display: "none"});
      });
    }});
    tl.set(".PageAnimation",{ display: "block"});
  },
  
	beforeRouteLeave (to, form, next) {
    let tl = new TimelineLite({ onComplete: () => {
      store.commit("stopToSetFollowAnimation");
      store.commit("toggleInitOpen");
      setTimeout( () => { 
        store.commit("toggleInitOpen");
        store.commit("toggleOpen") 
      }, 100);
      setTimeout( () => { next(); }, 800);
      tl.kill();
    }});
    tl.set(".PageAnimation",{ display: "block"});
  },

  beforeUnmount() {
    this.unsubscribe();
    this.clearRepeatingUpdateIndex();
    this.unsubscribe = null;
    // mount後から5000ms後にrepeatが発火するので爆速で他のページにいくとバグるので5000ms後にclearする
    setTimeout(()=>{
      this.clearRepeatingUpdateIndex();
      this.events["intervalUpdateIndex"] = null;
    },3800);
  },

  methods: {
    removePinkMode() {
      const mvbgEl = document.querySelector(".bgLayer");
      const canvasEl = document.querySelector("canvas");
      const menuEl = document.querySelector(".menu");
      util.addactive(mvbgEl);
      util.addactive(canvasEl);
      util.addactive(menuEl,"forcePink");
    },

    setMetaInfo(targetCategory) {
      document.title = targetCategory.name + "｜MAMADAYS総選挙2020";
      document.querySelector("meta[name='description']").setAttribute('content', "『MAMADAYS総選挙』結果発表中！全国のママとパパが【" + targetCategory.name + "】ジャンルにおいて投票した「使ってよかった！」「これからも使い続けたい！」という商品やサービスをご紹介します。");
    },

    SetTargetCategory(){
      const isCategory = this.categoryDefinition["categorys"] && this.categoryDefinition["categorys"].length ? true : false;
      if( isCategory ){
        const paramId = this.$route.params.id;
        const target = this.categoryDefinition.categorys.filter( (category,index) => {
          if(category.id == paramId) { 
            this.targetCategoryNumber = index + 1
            return true
          } else {
            return false
          }
        });
        if (target.length) { 
          this.targetCategory = target[0];
          this.setMetaInfo(this.targetCategory);
        }
      }
    },

    sendTracking(action,category,label){
      const tagExclusionLabel = label.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'');
      this.$gtag.event(action, {
        'event_category' : category,
        'event_label' : tagExclusionLabel
      });
    },

    repeatingUpdateIndex()  {
      this.clearRepeatingUpdateIndex();
      this.autoUpdateIndex();
      this.events["intervalUpdateIndex"] = setTimeout(this.repeatingUpdateIndex, 5000);
    },

    clearRepeatingUpdateIndex()  {
      if(this.events["intervalUpdateIndex"]) {
        clearTimeout(this.events["intervalUpdateIndex"]);
      }
    },

    autoUpdateIndex(){
      const categoryDefinition = this.categoryDefinition.categorys;
      categoryDefinition.forEach((category,i) =>  {
        const departmentsLength  = category.departments.length;
        const representativeIndex = (category.representativeIndex + 1) % departmentsLength;
        this.updateIndex(i,representativeIndex);
      })
    },

    updateIndex(index,dindex){
      const target = this.categoryDefinition ? this.categoryDefinition.categorys[index] : null
      if(target && this.targetCategory.id !== "money") {
        const productImage =  document.querySelector(".categorysPage .productImage .product");
        let timing = this.isSp ? 500 : 200;
        if(productImage) {
          util.removeactive(productImage);
          this.categoryDefinition.categorys[index].representativeIndex = dindex
          setTimeout(()=>{
            util.addactive(productImage);
          },timing);
        }
      }
    },

    hiddenNavigation() {
      const menuEl = document.querySelector(".menu");
      const navEl = document.querySelector("#navigation");
      const elbody = document.querySelector("body");
      if(menuEl.classList.contains("active")) {
          elbody.style.overflow = "visible";
          util.addactive(navEl, "deactive");
          util.removeactive(menuEl);
          util.removeactive(navEl);
          setTimeout(()=>{
            navEl.style.display = "none";
          },800);
      }
    },

    openContent: function(e,afterText,beforeText) {
      let el_parent = e.currentTarget.parentNode;
      let el_inner = ""
      let textel =  el_parent.getElementsByClassName("text")[0];
      let clickel = e.currentTarget;
      if(el_parent.classList.contains("opened")){
        el_parent.classList.remove("opened");
        el_parent.classList.add("closed");
        textel.textContent = beforeText + "...";
        clickel.getElementsByTagName("span")[0].textContent = "VIEW MORE";
      } else {
        el_parent.classList.remove("closed");
        el_parent.classList.add("opened");
        textel.textContent = afterText;
        clickel.getElementsByTagName("span")[0].textContent = "CLOSE";
      }
      e.preventDefault();
    }
  }
}
</script>

<style lang="scss">
.titleLinelogo {
  top: displaysize(76);
  left: displaysize(71);
  position: absolute;
  @include hoverlink;
  width: displaysize(345);
  &:hover {
    cursor: pointer;
  }
}
.categorysPage {
    .toScroll {
      position: fixed;
      width: displaysize(45);
      left: 4%;
      bottom: 4%;
      backface-visibility: hidden;
      @include hoverlink;
      &.remove {
        opacity: 0;
      }
      &:hover {
        cursor: pointer;
      }
    }
    .categoryTitle {
      width: percent_resize(1240,1920);
      height: displaysize(107);
      margin: percent_resize(241,1920) 0 percent_resize(280,1920) 0;
      position: relative;
      @include resizebywidth_lessthan(1330px){
        width: 70%;
      }
      .productImage {
        position: absolute;
        width: 83%;
        left: -3%;
        top: 0%;
        transform: none;
        @include resizebywidth_lessthan(1330px){
          width: 78%;
        }
        .horizontalBar {
          border-radius: 200px;
          height: displaysize(107);
          width: 100%;
          will-change: background-color;
          @include transition_anim($duration-time: 1.0s, $propertys: (background-color));
        }
        .number {
          position: absolute;
          display: inline-block;
          font-size: displaysize(45);
          font-weight: bold;
          top: 50%;
          right: calc(50% + #{displaysize(45)});
          transform: translate(0,-54%);
          z-index: 2000;
          color: #ffffff;
        } 
        .product {
          position: absolute;
          width: percent_resize(320,1090);
          top: 30%;
          right: 8%;
          transform: translate(0,-50%);
          z-index: 2000;
          &.active {
            img {
              @include transition_anim($duration-time: 1.0s);
              transform: translate(0,0);
              opacity: 1;
            }
          }
          img {
            will-change: transform,opacity;
            transform: translate(0,40px);
            opacity: 0;
          }
        }
      }
      .pageLink {
        float: right;
        display: block;
        font-family: 'M PLUS Rounded 1c', sans-serif;
        font-size: displaysize(28);
        margin-top:  displaysize(30);
        transform: translate(50%, 0);
        color: #BEBEBE;
        span {
          color: $fontPink;
        }
      }
    }

    .departments {
      width: percent_resize(1100,1920);
      min-width: 808px;
      margin: 0 auto;
      @include clearfix;
      .department {
        @include clearfix;
        position: relative;
        .item_container {
          display: flex;
          flex-wrap: wrap;
          > section:nth-of-type(2n) {
            margin-right: 0;
          }
        }
        > h3.title {
          font-family: 'M PLUS Rounded 1c', sans-serif;
          font-size: displaysize(32);
          font-weight: 500;
          position: relative;
          display: block;
          text-align: center;
          color: #404040;
          margin: 0 auto displaysize(180) auto;
          &:before {
            @include content_pseudo;
            width: percent_resize(44,1100);
            padding-top: percent_resize(37,1100);
            max-width: 32px;
            max-height: 24px;
            top: -110%;
            left: 50%;
            transform: translate(-50%,0);
            background-image: url("~@/assets/images/title_crown.png");
            background-repeat: no-repeat;
            background-size: 100% auto;
          }
        }
        .product {
          width: 42%;
          margin-bottom: displaysize(190);
          margin-right: 16%;
          position: relative;
          font-family: 'M PLUS Rounded 1c', sans-serif;
          .companyName {
            font-size: displaysize(20);
            text-align: center;
            color: #BEBEBE;
            margin-bottom: displaysize(16);
          }
          figure {
            position: relative;
            margin-bottom: 4%;
            width: 100%;
            padding-top: 100%;
            background-color: #ffffff;
            .award {
              position: absolute;
              left: -12%;
              top: -10%;
              width: displaysize(160);
              z-index: 2000;
            }
            img {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              z-index: 500;
            }
            // margin-bottom: displaysize(28);
          }
          .name {
            text-align: center;
            white-space: nowrap;
            font-weight: 600;
            color: #171717;
            font-size: displaysize(30);
            small {
              font-size: displaysize(20);
            }
          }
          .button {
            @include btn_style(#{displaysize(370)},#{displaysize(47)},$btn_color: $buttonPink,$color: #ffffff);
            margin: 6% auto displaysize(35.5) auto;
            position: relative;
            will-change: transform;
            overflow: hidden;
            z-index: 500;
            transform: translate(0);
            @include transition_anim($duration-time: 0.8s, $propertys: (transform));
            &:hover {
              transform: scale(1.05);
              cursor: pointer;
              &:after {
                width: 600px;
                height: 600px;
              }
              .bg {
                &:after {
                  left: 200%;
                  opacity: 0;
                }
                &:before {
                  left: 50%;
                  opacity: 1;
                }
              }
            }
            .textEl{
              position: relative;
              display: inline-block;
              font-weight: 500;
              font-size: 12px;
              z-index: 500;
            }
            &:after {
              @include content_pseudo;
              background-color: #bcbcbc;
              width: 0;
              height: 0;
              bottom: -300px;
              border-radius: 50%;
              z-index: 0;
              @include transition_anim($duration-time: 2.0s,$propertys:(width,height));
            }
            .bg {
              display: block;
              position: absolute;
              width: displaysize(24);
              height: displaysize(24);
              right: 12px;
              top: 50%;
              overflow: hidden;
              transform: translate(0,-50%);
              border-radius: 50%;
              border: 1px solid #ffffff;
              z-index: 500;
              &:after {
                @include content_pseudo;
                width: 50%;
                height: 50%;
                left: 50%;
                top: 50%;
                background-image: url("~@/assets/images/icon_arrow_pink_hover.png");
                background-size: 100% auto;
                transform: translate(-50%,-50%);
                opacity: 1;
                will-change: left,opacity;
                @include transition_anim($duration-time: 0.4s,$propertys:(left,opacity));
                transition-timing-function: cubic-bezier(0.76, 0, 0.24, 1);
              }
              &:before {
                @include content_pseudo;
                width: 50%;
                height: 50%;
                left: -100%;
                top: 50%;
                background-image: url("~@/assets/images/icon_arrow_pink_hover.png");
                background-size: 100% auto;
                transform: translate(-50%,-50%);
                opacity: 0;
                will-change: left,opacity;
                @include transition_anim($duration-time: 0.4s,$propertys:(left,opacity));
                transition-timing-function: cubic-bezier(0.76, 0, 0.24, 1);
              }
            }
          }
        } 
      }

      .annotation {
        display: block;
        margin-top: 5%;
        width: 80%;
        font-size: 9px;
        color: #BEBEBE;
        letter-spacing: 0.01em;
        margin-left: 20%;
        span,small {
          display: block;
          margin-bottom: 2%;
        }
      }
    }

    .kutikomi {
      .comment {
        position: relative;
        @include clearfix;
        width: 100%;
        margin: 0 auto;
        margin-bottom: 3.2%;
        font-family: 'M PLUS Rounded 1c', sans-serif;
        .mamasIcon {
          position: absolute;
          width: 12%;
          left: 0;
          top: 50%;
          transform: translate(0,-50%);
        }
        .message {
          box-sizing: border-box;
          padding: displaysize(21) displaysize(35) 0 displaysize(35);
          float: right;
          background-color: #ffffff;
          border-radius: 20px;
          border: 1px solid #cccccc;
          width: 81%;
          position: relative;
          &:before {
            @include content_pseudo;
            width: 0;
            height: 0;
            left: calc(0% - 21px);
            top: calc(23.5% + 1px);
            border-style: solid;
            transform: rotate(-90deg);
            border-width: 0 12px 21px 12px;
            z-index: 900;
            border-color: transparent transparent #ffffff transparent;
          }
          &:after {
            @include content_pseudo;
            width: 0;
            height: 0;
            left: calc(0% - 24px);
            top: 23.5%;
            transform: rotate(-90deg);
            border-style: solid;
            border-width: 0 13px 23px 13px;
            z-index: 600;
            border-color: transparent transparent #cccccc transparent;
          }
          .text {
            display: flex;
            align-items: center;
            letter-spacing: 0.01em;
            font-size: 13px;
            padding-bottom: displaysize(21);
            min-height: 35px;
            will-change: height;
          }
          .viewMore {
            letter-spacing: 0.2em;
            font-size: 11px;
            color: $fontPink;
            text-align: center;
            display: inline-block;
            margin: 0 auto displaysize(15) auto;
            position: relative;
            left: 47%;
            transform: translate(-50%,0);
            @include hoverlink;
            &:hover {
              cursor: pointer;
            }
            .circle {
              display: block;
              position: absolute;
              right: -30%;
              top: 50%;
              transform: translate(0, -50%);
              width: displaysize(34);
              height: displaysize(34);
              &:before, &:after {
                @include content_pseudo;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                will-change: transform;
                width: displaysize(15);
                height: 1px;
                border-radius: 3px;
                background-color: $fontPink;
              }
              &:after {
                will-change: transform;
                @include transition_anim($duration-time: 1.0s);
                transform: translate(-50%,-50%) rotate(450deg);
              }
            }
          }
          &.opened {
            .viewMore {
              .circle {
                right: -60%;
                &:after {
                  transform: translate(-50%,-50%) rotate(0deg);
                }
              }
            }
          }
        }
        .show_area {
          height: 0;
          overflow: hidden;
        }
      }
    }

    .categoryLinks {
      width: displaysize(1300);
      padding-top: displaysize(80);
      margin:  0 auto;
      font-family: 'M PLUS Rounded 1c', sans-serif;
      > .title {
        font-size: displaysize(34);
        text-align: center;
        margin-bottom: displaysize(58);
        font-weight: 600;
      }
      .links {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: displaysize(263);
        li {
          text-align: center;
          margin-bottom: displaysize(28);
          margin-right: 66px;
          a {
            display: inline-block;
            position: relative;
            font-size: displaysize(26);
            color: $fontPink;
            white-space: nowrap;
            font-weight: 500;
            &:hover {
              .bg {
                .circle {
                  background-color: $fontPink;
                  width: 160%;
                  padding-top: 160%;
                  height: auto;
                  top: -34%;
                  left: -29%;
                }
                &:after {
                  opacity: 0.0; 
                }
                &:before { 
                  opacity: 1.0; 
                }
              }
            }
            .bg {
              display: block;
              position: absolute;
              width: displaysize(25);
              padding-top: displaysize(25);
              right: -28px;
              top: 50%;
              transform: translate(0,-50%);
              .circle {
                display: block;
                position: absolute;
                width: 100%;
                padding-top: 100%;
                border-radius: 50%;
                border: 1px solid $fontPink;
                left: 0;
                top: 0;
                z-index: 0;
                will-change: background-color,padding-top,width;
                background-color: transparent;
                @include transition_anim($duration-time: 0.8s, $propertys: (background-color,width,padding-top,left,top));
                backface-visibility: hidden;
              }
              &:after {
                @include content_pseudo;
                width: 56%;
                height: 56%;
                background-size: 100% auto;
                left: 56%;
                top: 54%;
                transform: translate(-50%,-50%);
                z-index: 100;
                background-image: url("~@/assets/images/icon_arrow_pink.png");
                background-repeat: no-repeat;
                background-size: 100% auto;
                will-change: opacity;
                @include transition_anim($duration-time: 1.0s, $propertys: (opacity));
              }
              &:before {
                @include content_pseudo;
                width: 56%;
                height: 56%;
                background-size: 100% auto;
                left: 56%;
                top: 54%;
                transform: translate(-50%,-50%);
                background-image: url("~@/assets/images/icon_arrow_pink_hover.png");
                background-repeat: no-repeat;
                background-size: 100% auto;
                z-index: 200;
                opacity: 0;
                will-change: opacity;
                @include transition_anim($duration-time: 1.0s, $propertys: (opacity));
              }
            }
          }
        }
      }
    }
}
@import "./scss/categorys_sp.scss";
</style>
